<app-loader *ngIf="isDisabled"></app-loader>
<div>
	<div class="row m-0">
		<div class="col"></div>
		<div class="col-auto">
			<button type="button" *ngIf="this.common.PageRight.IsAdd" class="btn btn-primary"  [routerLink]="['/employeeconfirmation/Questionnaire/add/',0]" [disabled]="isDisabled">
				<i class="bi bi-ui-checks" *ngIf="!isDisabled"></i>
				<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
					*ngIf="isDisabled"></span>
				{{!isDisabled?'Add Questionnaire':'Loading...'}}
			</button>
		</div>
	</div>
	<div class="card border-radius-0 mt-1 p-0">
		<div class="card-header">
			Questionnaire
		</div>
		<div class="card-body p-1">
			<table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger" class="customeDatatable table table-bordered">
				<thead class="table-light">
					<tr>
						<th scope="col" style="width: 5px;">#</th>
						<th style="width: 5px;" [ngClass]="{'colHide': !this.common.PageRight.IsEdit}">Action</th>
						<th>Template Name</th>
						<th style="width: 120px;">Module Name</th>
						<th style="width: 50px;">Default</th>
						<th style="width: 50px;">Active</th>
					</tr>
				</thead>
				<tbody>
					<tr *ngFor="let TableData of TableDatas; let i = index">
						<th scope="row" style="width: 5px;">{{i+1}}</th>
						<td style="width: 5px;" [ngClass]="{'colHide': !this.common.PageRight.IsEdit}"><div class="text-center"><i [routerLink]="['/employeeconfirmation/Questionnaire/add/',TableData['ESS_QuestionnareTemplateMainId']]" class="bi bi-pencil-square text-warning"></i></div></td>
						<td>{{TableData['TemplateName']}}</td>
						<td style="width: 120px;">{{TableData['ModuleName']}}</td>
						<td style="width: 50px;">{{TableData['DefaultTemplate']?'Yes':'No'}}</td>
						<td style="width: 50px;">{{TableData['IsActive']?'Yes':'No'}}</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
</div>